import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import FAQItem from './FAQItem'
import './support-styles.css'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-110112779-1');
ReactGA.pageview(window.location.pathname + window.location.search);

let faqs = [
  {
    q: "I'm subscribed to GO Plus, but the app says I need to upgrade. What do I do?",
    a: "You can try restoring your purchase in the settings screen by tapping \"Restore Purchases\". If that does not work, then please try reinstalling UniversityGO and restoring your purchase again. If you still cannot restore your subscription, then please submit a problem through the app."
  },
  {
    q: "How do I manage my GO Plus subscription?",
    a: "On the settings screen, tap on the Subscription Info button. You can then tap \"Manage Subscription\" to manage your subscription preferences."
  },
  {
    q: "How do I report a bug or give you feedback?",
    a: "On the settings screen, tap on the \"Submit Feedback or Report Problem\" button. A form will pop up allowing you to send us a message with any feedback or problem you may be experiencing. You can also leave us a review on the App Store or Google Play Store."
  }
]

let iosCancelRefund = <div>
  <h3>Cancel Subscription</h3>
  <p>If you need to cancel your GO Plus subscription, you can do so through the UniversityGO app by following the steps below:</p>
  <ol>
    <li>Open UniversityGO and tap the <strong>info button</strong> on the top right of the navigation bar to open the settings page.</li>
    <li>Tap on the <strong>Subscription Info</strong> button. This will open the GO Plus page.</li>
    <li>Tap the <strong>Manage Subscription</strong> button to be redirected to the iTunes Store.</li>
    <li>Tap <strong>Cancel Subscription</strong> to cancel your subscription.</li>
  </ol>
  <h3>Refund Subscription</h3>
  <p>UniversityGO does not have the ability to process refunds since all purchases are process through the Apple App Store. Refunds are available for purchases made in the last 90 days. To request a refund through Apple, follow the steps below:</p>
  <ol>
    <li>Navigate to <strong><a href="https://reportaproblem.apple.com/">https://reportaproblem.apple.com/</a></strong></li>
    <li>Login with your<strong> Apple ID</strong></li>
    <li>Find <strong>UniversityGO, GO Plus (Automatic Renewal)</strong> in your <strong>Purchases</strong> list</li>
    <li>Click on <strong>Report a Problem</strong></li>
    <li>In the <strong>Choose Problem</strong> drop down, select <strong>"Didn't mean to purchase this item"</strong></li>
  </ol>
  <p>Apple should then process the refund within 48 hours</p>
  </div>

export default class Support extends Component {

  constructor(props){
    super(props)
    this.state = {items:this.createFaqs()}
  }

  createFaqs() {
    let faqItems = faqs.map((faq, index) => {
      return <Row><FAQItem key={index} q={faq.q} a={faq.a} /></Row>
    })
    return faqItems
  }

  render() {

    return (
      <div>
          <div className='support-landing-image'>
            <Row center='xs' middle='xs' id='support-heading-row'>
              <Col lg={24} md={12} sm={24} xs={24}>
                <div>
                  <h1 className='gradientH1 landing-heading'>Support</h1>
                  <h3 id="landing-subheading">We're Here to Help.</h3>
                  <Row id="button-row" center='xs'>
                    <Col className="faq-container" md={2} xs={12}>
                      <a className="faq-link" href="#faq">FAQ</a>
                    </Col>
                    <Col className="faq-container" md={2} xs={12}>
                      <a className="faq-link" href="#ios">iOS Guide</a>
                    </Col>
                    <Col className="faq-container" md={2} xs={12}>
                      <a className="faq-link" href="#android">Android Guide</a>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        <div id="faq-container">
          <Row>
            <h1 id="faq" className="support-heading">Frequently Asked Questions</h1>
          </Row>
          {this.state.items}
          <Row>
            <h1 id="ios" className="support-heading">iOS Guide</h1>
          </Row>
          
          <Row>
            <p>Full User Guide Coming Soon</p>
          </Row>
          <Row>
            <FAQItem q="Cancel or Refund Your GO Plus Subscription" a={iosCancelRefund}/>
          </Row>
          <Row>
            <h1 id="android" className="support-heading">Android Guide</h1>
          </Row>
          <Row>
            <p>Coming Soon</p>
          </Row>
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Support/Support.js